import { useState } from "react";
import SearchBar from "components/base/SearchBar";

const ReportList = ({ reports }) => {
  const [showIssueReports, setShowIssueReports] = useState(false);
  const [showZeroIssues, setShowZeroIssues] = useState(false);
  const [issueSearch, setIssueSearch] = useState("");
  const [zeroIssueSearch, setZeroIssueSearch] = useState("");

  const reportsWithIssues = reports
    .filter((report) => report.issue_rate > 0)
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const reportsWithoutIssues = reports
    .filter((report) => report.issue_rate === 0)
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const filterReports = (reportList, search) => {
    const query = search.trim().toLowerCase();
    if (!query) return reportList;

    return reportList.filter((report) =>
      [report.name, report.created_at, ...report.issue_types]
        .join(" ")
        .toLowerCase()
        .includes(query),
    );
  };

  const renderReport = (report) => (
    <div
      key={report.id}
      className="border-b border-dashed dark:border-gray-700 py-2 flex justify-between"
    >
      <a href={`/qc/reports/${report.id}`} target="_blank" rel="noreferrer">
        {report.name}&nbsp;&nbsp;|&nbsp;&nbsp;{report.created_at}
      </a>

      <div className="w-40 ml-4 opacity-70">
        <div>
          Issue {report.issue_rate}% ({report.issue_qty} / {report.check_qty})
        </div>

        {report.issue_types.map((desc, index) => (
          <div key={index} className="opacity-70">
            {desc}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-2 text-sm">
      <h4 className="text-base">Reports</h4>

      {reportsWithIssues.length > 0 && (
        <div className="flex flex-col gap-2">
          <button
            onClick={() => setShowIssueReports(!showIssueReports)}
            className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 flex items-center gap-1"
          >
            <span>{showIssueReports ? "▼" : "▶"}</span>
            <span>Issue Reports ({reportsWithIssues.length})</span>
          </button>
          {showIssueReports && (
            <div className="flex flex-col gap-2">
              <SearchBar
                value={issueSearch}
                onChange={setIssueSearch}
                placeholder="Search report, date or issue type"
              />
              <div className="max-h-80 overflow-y-auto">
                {filterReports(reportsWithIssues, issueSearch).map(
                  renderReport,
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {reportsWithoutIssues.length > 0 && (
        <div className="flex flex-col gap-2">
          <button
            onClick={() => setShowZeroIssues(!showZeroIssues)}
            className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 flex items-center gap-1"
          >
            <span>{showZeroIssues ? "▼" : "▶"}</span>
            <span>Zero Issue Reports ({reportsWithoutIssues.length})</span>
          </button>
          {showZeroIssues && (
            <div className="flex flex-col gap-2">
              <SearchBar
                value={zeroIssueSearch}
                onChange={setZeroIssueSearch}
                placeholder="Search report or date"
              />
              <div className="max-h-80 overflow-y-auto">
                {filterReports(reportsWithoutIssues, zeroIssueSearch).map(
                  renderReport,
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReportList;
